import { BlockDeprecation } from "@wordpress/blocks";
import v1 from "./v1/v1";
const deprecated = [v1] as unknown as BlockDeprecation<any>;

export default deprecated;
